import { displayDate } from '@adsk/alloy-react-datetime';
export default function getFieldValue(_ref) {
  let {
    date,
    startDate,
    endDate,
    range,
    format,
    locale,
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  } = _ref;
  if (range) {
    return [startDate ? displayDate(startDate, {
      format,
      locale,
      timeZone
    }) : null, endDate ? displayDate(endDate, {
      format,
      locale,
      timeZone
    }) : null];
  } else {
    return date ? displayDate(date, {
      format,
      locale,
      timeZone
    }) : null;
  }
}
//# sourceMappingURL=getFieldValue.js.map